module.exports = __webpack_public_path__ + "media/img/paygold/step1-d421b57b5515d7d24a9d87afee319c9c.png";